import { useLocalStorage } from "@ugitgud/legos/hooks/useLocalStorage";
import { isAfter, subHours } from "date-fns";
import { useLayoutEffect, useState } from "react";
import { YEAR_IN_REVIEW_BANNER_CTA } from "@ugitgud/legos/components/banner/YearInReviewBanner";

export const CURRENT_ACTIVE_BANNER = YEAR_IN_REVIEW_BANNER_CTA;

export function useBanner(ctaId: string = CURRENT_ACTIVE_BANNER) {
  const [bannerClosed, setBannerClosed] = useState(true);
  const [bannerDismissedDate, setBannerDismissedDate] = useLocalStorage<{ dismissedDate?: string }>(`ugg-cta-${ctaId}`, {
    dismissedDate: undefined,
  });
  useLayoutEffect(() => {
    const shouldBeClosed =
      !!bannerDismissedDate.dismissedDate && isAfter(new Date(bannerDismissedDate.dismissedDate), subHours(new Date(), 1));
    setBannerClosed(shouldBeClosed);
  }, [bannerDismissedDate.dismissedDate]);

  const setBannerOpen = (value: boolean) => {
    if (!value) {
      setBannerDismissedDate({ dismissedDate: new Date().toISOString() });
    }
    setBannerClosed(!value);
  };

  return {
    open: !bannerClosed,
    dismissedDate: bannerDismissedDate.dismissedDate,
    setBannerOpen,
  };
}
